import { render, staticRenderFns } from "./AppointmentAddEditModal.vue?vue&type=template&id=160b6787&scoped=true&"
import script from "./AppointmentAddEditModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentAddEditModal.vue?vue&type=style&index=0&id=160b6787&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b6787",
  null
  
)

export default component.exports